import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b10b5ec8&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=b10b5ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10b5ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10b5ec8')) {
      api.createRecord('b10b5ec8', component.options)
    } else {
      api.reload('b10b5ec8', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b10b5ec8&scoped=true&", function () {
      api.rerender('b10b5ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PyppVq2E3p5j/JS/comp/DateRangeExt.vue"
export default component.exports